module.exports = __webpack_public_path__ + "static/media/CoatingIcon.c2523e2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/CoatingIcon.png
// module id = 1802
// module chunks = 0